import ProfilePicture from 'components/elements/ProfilePicture'
import Stack from 'components/elements/Stack'
import { User } from 'interfaces/User'
import FeatureDialog from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import { Body1 } from 'stories/elements/Typography/Text'
import styled from 'styled-components'

const MembersWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    place-content: center;
    align-items: center;
    gap: 15px;
`

interface Props {
    open: boolean
    onClose: () => void
    groupMembers: User[]
}

const ChatMembersDialog = ({ open, onClose, groupMembers }: Props) => {
    return (
        <FeatureDialog
            open={open}
            onClose={onClose}
            ariaPrefix="chat-members"
            title={'Group members'}
            maxWidth={500}
            allowVerticalOverflow
        >
            <br />
            <Stack>
                {groupMembers.map((member) => (
                    <MembersWrapper key={member.name}>
                        <ProfilePicture user={member} size={50} />
                        <Body1 fontFamily="var(--font-inter)" fontWeight={400}>
                            {`${member.name} (${member.username})  ${member.isAdmin ? `- (Admin)` : ''}`}
                        </Body1>
                    </MembersWrapper>
                ))}
            </Stack>
        </FeatureDialog>
    )
}

export default ChatMembersDialog
